var Instafeed = require('instafeed.js')

/**
* Instagram Feed component
* @author Dayne Coulson-Hoffacker
*/
export default class InstagramFeed {
  /**
  * Constructs a new Instagram Feed instance
  * @param {Object} options - Options object.
  * @param {HMTLElement} options.element - Container element.
  */
  constructor (options) {
    this.element = options.element

    if (this.element.classList.contains('make-models')) {
      fetch('https://ig.instant-tokens.com/users/b5bde12f-9607-4f3d-939a-f9f12758fb34/instagram/17841401854255884/token?userSecret=sxsdm0w92imqkrb3dxl96g')
      .then(resp => resp.json())
      .then(data => {
        const feed = new Instafeed({
          accessToken: data.Token,
          limit: 4,
          template: '<a href="{{link}}" target="_blank"><figure><img src="{{image}}" /></figure></a>',
        });

        feed.run();
      })
      .catch((error) => {
        console.log(error)
      })
    } else {
      fetch('https://ig.instant-tokens.com/users/b5bde12f-9607-4f3d-939a-f9f12758fb34/instagram/17841404369675456/token?userSecret=jqqjilqd21q3q96unu6uny')
      .then(resp => resp.json())
      .then(data => {
        const feed = new Instafeed({
          accessToken: data.Token,
          limit: 4,
          template: '<a href="{{link}}" target="_blank"><figure><img src="{{image}}" /></figure></a>',
        });

        feed.run();
      })
      .catch((error) => {
        console.log(error)
      })
    }
  }
}



// WEBPACK FOOTER //
// ./components/instagram-feed/index.js